var _linearGradient, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlassianBitbucketLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 133.972825,
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 443.43 98.26",
    width: 746.420027,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 64.01,
    x2: 32.99,
    y1: 65.26,
    y2: 89.48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 41.25a2 2 0 0 0 -2 2.32l8.49 51.54a2.72 2.72 0 0 0 2.66 2.27h40.73a2 2 0 0 0 2-1.68l8.51-52.11a2 2 0 0 0 -2-2.32zm35.75 37.25h-13l-3.52-18.38h19.67z",
    fill: "#2684ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.67 60.12h-18.77l-3.15 18.38h-13l-15.35 18.23a2.71 2.71 0 0 0 1.75.66h40.74a2 2 0 0 0 2-1.68z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#253858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.49 5.22c0 2.6 1.21 4.66 5.92 5.57 2.81.59 3.4 1 3.4 2s-.59 1.5-2.57 1.5a14.51 14.51 0 0 1 -6.83-1.85v4.23a14 14 0 0 0 6.78 1.47c4.93 0 6.88-2.2 6.88-5.46m0 0c0-3.08-1.63-4.53-6.24-5.52-2.54-.56-3.16-1.12-3.16-1.93 0-1 .91-1.45 2.6-1.45a14.63 14.63 0 0 1 5.95 1.47v-4a13.44 13.44 0 0 0 -5.83-1.25c-4.55 0-6.91 2-6.91 5.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.79.27v17.59h3.75v-13.41l1.58 3.56 5.31 9.85h4.71v-17.59h-3.75v11.35l-1.42-3.29-4.26-8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.85.27h4.1v17.6h-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.12 12.67c0-3.08-1.63-4.53-6.24-5.52-2.54-.56-3.16-1.12-3.16-1.93 0-1 .91-1.45 2.6-1.45a14.63 14.63 0 0 1 5.95 1.47v-4a13.44 13.44 0 0 0 -5.82-1.24c-4.55 0-6.91 2-6.91 5.22 0 2.6 1.21 4.66 5.92 5.57 2.81.59 3.4 1 3.4 2s-.59 1.5-2.57 1.5a14.51 14.51 0 0 1 -6.83-1.85v4.23a14 14 0 0 0 6.78 1.47c4.93 0 6.88-2.2 6.88-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.65.27v17.59h8.43l1.32-3.8h-5.62v-13.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.01.27v3.8h4.56v13.79h4.12v-13.79h4.87v-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 .27h-5.4l-6.14 17.6h4.69l.87-3a11.65 11.65 0 0 0 6.56 0l.87 3h4.69zm-2.7 11.46a8 8 0 0 1 -2.25-.32l2.25-7.68 2.25 7.68a8 8 0 0 1 -2.22.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.6.27h-5.4l-6.14 17.6h4.69l.87-3a11.65 11.65 0 0 0 6.56 0l.87 3h4.69zm-2.7 11.46a8 8 0 0 1 -2.25-.32l2.25-7.68 2.25 7.68a8 8 0 0 1 -2.26.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.71.27h-5.4l-6.14 17.6h4.69l.87-3a11.65 11.65 0 0 0 6.56 0l.87 3h4.69zm-2.71 11.46a8 8 0 0 1 -2.25-.32l2.25-7.69 2.25 7.68a8 8 0 0 1 -2.25.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.87 39.57c11.79 0 17.51 5.81 17.51 15.14 0 7-3.17 11.26-9.68 12.85 8.54 1.41 12.76 6.07 12.76 14.26 0 9.24-6.25 15.58-19.18 15.58h-23.85v-57.83zm-14.52 7.57v17.24h13.46c7.48 0 10.56-3.43 10.56-9s-3.34-8.27-10.56-8.27zm0 24.29v18h16.19c7.57 0 11-2.73 11-8.54 0-6.16-3.26-9.5-11.17-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.4 36.49a4.94 4.94 0 0 1 5.28 5.28 5.28 5.28 0 0 1 -10.56 0 4.94 4.94 0 0 1 5.28-5.28zm-3.87 16.89h7.57v44h-7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183 90a24 24 0 0 0 4.75-.62v7.3a18.19 18.19 0 0 1 -5.1.7c-9.42 0-14-5.54-14-13.73v-23.23h-7.13v-7h7.13v-9.36h7.35v9.33h11.7v7h-11.7v23.09c0 3.87 2.29 6.52 7 6.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.95 98.26c-6.42 0-11.35-2.9-14-8.62v7.74h-7.57v-62.38h7.62v26.3c2.82-5.81 8.1-8.8 14.87-8.8 11.7 0 17.6 9.94 17.6 22.88-.04 12.41-6.2 22.88-18.52 22.88zm-1.15-38.72c-6.8 0-12.8 4.32-12.8 14.08v3.52c0 9.77 5.54 14.08 12 14.08 8.54 0 12.94-5.63 12.94-15.84-.08-10.56-4.3-15.84-12.14-15.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.35 53.38h7.57v26.62c0 7.92 3.17 11.44 10.38 11.44 7 0 11.88-4.66 11.88-13.55v-24.51h7.57v44h-7.57v-7.21a15.43 15.43 0 0 1 -13.9 8.1c-10.12 0-15.93-7-15.93-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.25 96.24c-2.64 1.41-6.69 2-10.74 2-15.66 0-23-9.5-23-23 0-13.29 7.3-22.79 23-22.79a23.26 23.26 0 0 1 10.49 2.17v7a22.18 22.18 0 0 0 -10-2.08c-11.44 0-16.1 7.22-16.1 15.75s4.79 15.71 16.32 15.71a27.8 27.8 0 0 0 10-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.88 97.38v-62.38h7.57v39l18.92-20.59h9.86l-20.69 21.59 21.56 22.38h-10.3l-19.36-20.59v20.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.18 98.26c-16.46 0-23.67-9.5-23.67-23 0-13.29 7.39-22.79 20.77-22.79 13.55 0 19 9.42 19 22.79v3.43h-32.12c1.06 7.48 5.9 12.32 16.28 12.32a39 39 0 0 0 13.38-2.38v7c-3.61 1.93-9.15 2.63-13.64 2.63zm-16.1-26h24.55c-.44-8.18-4.14-12.85-11.7-12.85-8.02-.04-12.06 5.15-12.85 12.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.68 90a24 24 0 0 0 4.75-.62v7.3a18.19 18.19 0 0 1 -5.1.7c-9.42 0-14-5.54-14-13.73v-23.23h-7.13v-7h7.13v-9.36h7.39v9.33h11.7v7h-11.7v23.09c.01 3.87 2.28 6.52 6.96 6.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassianBitbucketLogo);
export default __webpack_public_path__ + "static/media/atlassian_bitbucket_logo.007c31b54d332cc873a25edde877e079.svg";
export { ForwardRef as ReactComponent };